var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm5.75-12.661a1.518 1.518 0 0 0-1.062-1.083C15.753 8 12 8 12 8s-3.753 0-4.688.256A1.518 1.518 0 0 0 6.25 9.339C6 10.293 6 12.286 6 12.286s0 1.992.25 2.947c.14.527.545.941 1.062 1.082.935.256 4.688.256 4.688.256s3.753 0 4.688-.256a1.518 1.518 0 0 0 1.061-1.082c.251-.955.251-2.947.251-2.947s-.001-1.993-.25-2.947Zm-6.951 4.783 3.117-1.836-3.117-1.837v3.673Z",
    fill: "currentColor"
  })));
};
export default SvgYoutube;